<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>홈페이지 제작</h1>
    </div>
    <div class="product"></div>
  </div>
</template>

<script>
export default {}
</script>

<style>
.product {
  border-top: solid 2px;
}
</style>
